import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import Link from "next/link";
import { BreadcrumbsProps } from "./interface";
import ChevronIcon from "@icons/Chevron";
import color from "@definitions/mui/color";
import Text from "@ds/components/Text";

const BreadcrumbsComponent = (props: BreadcrumbsProps) => {
  const { homeUrl, breadcrumbs, lastUrl, title = "", variant = "body1" } = props;
  const newData: Array<any> = [];

  const datas: Array<any> = lastUrl
    ? newData.concat(homeUrl, breadcrumbs, lastUrl)
    : newData.concat(homeUrl, breadcrumbs);

  return (
    <>
      {title && (
        <Text variant="h1" weight="700" sx={{ marginBottom: 8 }}>
          {title}
        </Text>
      )}
      <Breadcrumbs separator={<ChevronIcon style={{ width: 8, color: color.primary.main }} />}>
        {datas.map(({ label, productPath }, key) => {
          let content;
          const lastItem = datas.length - 1 === key;

          if (lastItem) {
            content = <Text variant={variant} color="general-mid">{label}</Text>;
          } else if (productPath) {
            content = (
              <Link href={productPath} passHref>
                <a style={{ textDecoration: "none" }}>
                  <Text variant={variant} color="primary-main">{label}</Text>
                </a>
              </Link>
            );
          } else {
            content = (
              <Text variant={variant} color="general-mid" weight="400">
                {label}
              </Text>
            );
          }

          return <Box key={key}>{content}</Box>;
        })}
      </Breadcrumbs>
    </>
  );
};

export default BreadcrumbsComponent;
